"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuSaveButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ActionMenuSaveButton = styled_components_1.default.button `
  background: rgba(30, 139, 33, 1);
  display: block;
  height: 30px;
  width: 70px;
  color: #fff;
  border-radius: 2px;
  box-shadow: none;
  border: none;
  margin-top: 10px;

  &:disabled {
    opacity: 0.5;
  }
`;
//# sourceMappingURL=action-menu-save-button.js.map